module.exports = __webpack_public_path__ + "img/result-detail-communication-inright02.7fb5aa45.svg";